<template>
    <ValidationObserver
        tag="form"
        ref="observer"
        @submit.prevent="handleSubmit"
    >
        <div class="row">
            <FormInput
                class="col-12"
                label="Nombre"
                tipe="text"
                name="Nombre"
                id="nombre"
                rules="required"
                v-model="carpetaLocal.nombre"
            />
            <div class="col-12 mt-3">
                <label for="descripcion">Descripción</label>
                <textarea
                    id="descripcion"
                    class="form-control"
                    placeholder="Descripción"
                    v-model="carpetaLocal.descripcion"
                ></textarea>
            </div>

            <div class="col-12 text-right mt-4">
                <Button type="submit" :disabled="loading">GUARDAR</Button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: {
            carpeta: {
                type: Object,
                default: () => ({
                    nombre: "",
                    descripcion: "",
                }),
            },
            loading: Boolean,
        },
        data() {
            return {
                carpetaLocal: { ...this.carpeta },
            };
        },
        methods: {
            async handleSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.$emit("submit", this.carpetaLocal);
                }
            },
        },
    };
</script>
